import { ReactNode, FC } from "react";

import Button from "../../../components/Desktop/Button";

const FoodHow = () => {
  return (
    <section className="relative z-0 pr-[120px] h-[830px] mb-[80px]">
      <div className="relative w-full h-full">
        {/* First Row */}
        <div className="scroll-mt-[90px]" id="food-how">
          <div className="w-[559px] h-[203px] bg-primaryDark-400 flex items-center justify-center">
            <h3 className="text-[36px] font-raleway font-semibold text-text-1000">
              How Does It Work?
            </h3>
          </div>
        </div>

        {/* Second Row */}
        <div className="bg-text-1000 border border-[#E9E9E9] rounded-[24px] absolute z-2 top-[140px] right-[70px] p-[50px]">
          {/* Cards */}
          <div className="grid grid-cols-2 grid-rows-2 gap-[24px] mb-[24px]">
            {/* Card One */}
            <FoodHowCard
              step={1}
              heading={<>Complete Your Profile</>}
              description={
                <>
                  Open an account on the{" "}
                  <span className="text-primaryDark-400 font-bold leading-loose">
                    {" "}
                    Resource Pantry{" "}
                  </span>{" "}
                  <br />
                  and complete your profile.
                </>
              }
            />

            {/* Card Two */}
            <FoodHowCard
              step={2}
              heading={
                <>
                  Get Matched to <br /> Listings
                </>
              }
              description={
                <>
                  Explore options in the area that fit your <br />
                  criteria.
                </>
              }
            />

            {/* Card Three */}
            <FoodHowCard
              step={3}
              heading={<>Request Culinary Resource</>}
              description={
                <>
                  Reserve your slot or request more <br />
                  information.
                </>
              }
            />

            {/* Card Four */}
            <FoodHowCard
              step={4}
              heading={<>Get Cooking!</>}
              description={
                <>
                  Now you can focus on developing <br />
                  mouthwatering recipes instead of logistics.
                </>
              }
            />
          </div>

          {/* Button */}
          <div className="scroll-mt-[100px]" id="food-how-box">
            <Button label="Watch Tutorials" variant="secondary" onClick={() => window.open("https://site.homecookapp.com/resource-pantry-step-categories", "_blank")} />
          </div>
        </div>
      </div>
    </section>
  );
};

type FoodHowCardProps = {
  step: number;
  heading: ReactNode;
  description: ReactNode;
};

const FoodHowCard: FC<FoodHowCardProps> = ({ step, heading, description }) => {
  return (
    <div className="border-[2px] border-dashed border-[#E9E9E9] rounded-[16px] p-[30px]">
      {/* Header */}
      <div className="flex items-center gap-[16px] mb-[16px]">
        <p className="text-[96px] font-raleway text-[#F5F5F5] leading-none">
          {step}
        </p>
        <h4 className="text-[24px] font-raleway font-semibold text-primaryDark-0 leading-tight">
          {heading}
        </h4>
      </div>

      <p className="text-[16px] font-open-sans text-text-0 leading-loose">
        {description}
      </p>
    </div>
  );
};

export default FoodHow;
